/* global
AP
*/
import swal from 'sweetalert'
import { hosts } from './hosts'

const initialExampleMap = { 'rules': [[]], 'questions': [] }

export default class JiraAdapter {
  constructor () {
    this.lastKnownExampleMap = ''
    this.jiraKey = ''
  }

  async load () {
    let issueKey = ''
    let response = await AP.context.getContext()
    issueKey = response.jira.issue.key
    window.amplitude.getInstance().logEvent('em_load_examplemap', { 'issue_key': issueKey })
    this.jiraKey = issueKey

    let exampleMap = await this.fetchExampleMap(`/rest/api/2/issue/${issueKey}/properties/tul-em`)
    if (exampleMap === null) {
      exampleMap = initialExampleMap
    }
    this.lastKnownExampleMap = JSON.stringify(exampleMap)
    return exampleMap
  }

  async save (state) {
    const stateToSaveStringified = JSON.stringify(state)
    const propertyUrl = '/rest/api/2/issue/' + this.jiraKey + '/properties/tul-em'

    // if the EM has been saved elsewhere give the option to reload or overwrite
    if (!await this.continueWithSave(propertyUrl)) {
      return true
    }

    await AP.request({
      url: propertyUrl,
      type: 'PUT',
      contentType: 'application/json',
      data: stateToSaveStringified
    })
    this.lastKnownExampleMap = stateToSaveStringified
    return false
  }

  async fetchExampleMap (propertyUrl) {
    try {
      const response = await AP.request(propertyUrl)
      return JSON.parse(response.body).value
    } catch (error) {
      if (error.xhr && error.xhr.status === 404) {
        return null
      } else {
        console.log(error)
        throw error
      }
    }
  }

  async continueWithSave (propertyUrl) {
    const exampleMap = await this.fetchExampleMap(propertyUrl)
    if (exampleMap === null) {
      return true
    }

    if (JSON.stringify(exampleMap) !== this.lastKnownExampleMap) {
      const shouldReloadExampleMap = await swal({
        title: 'Example Map has been saved since you last loaded it',
        text: 'Click Overwrite to save your changes, or Reload (and lose your last edit)',
        icon: 'warning',
        buttons: ['Overwrite', 'Reload']
      })
      if (shouldReloadExampleMap) {
        return false
      }
    }
    return true
  }

  async getCustomerIdentifier () {
    return new Promise(
      (resolve, reject) => {
        try {
          AP.getLocation(location => {
            location = location.substr(location.indexOf('//') + 2)
            location = location.split('.')[0]
            resolve(location)
          })
        } catch (err) {
          console.log(err)
          window.amplitude.getInstance().logEvent('em_cannot_get_customer')
          reject(err)
        }
      }
    )
  }

  getHost () {
    return hosts.JIRA
  }

  async loadInitialExampleMap () {
    return initialExampleMap
  }
}
